export default {
  nome: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  document: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  dataSituacaoInicial: {
    value: '',
    required: false,
    maxlength: 10,
    state: null
  },
  dataSituacaoFinal: {
    value: '',
    required: false,
    maxlength: 10,
    state: null
  },
  situacao: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/card/search/search-form.js